<template>
  <div id="container-header">
    <div id="nav">
      <div>
        <div class="text text-container">
          <div
            class="word"
            v-for="(word, index) in this.create_section()"
            v-bind:key="index"
          >
            <span
              v-for="(letter, index_) in word"
              :key="index_"
              :style="{ animationDelay: `${index_ * 0.1}s` }"
            >
              {{ letter }}
            </span>
          </div>
        </div>
      </div>
      <div id="previous-url">
        <a :href="previous_url">
          <img
            src="@/assets/home/gif_menu.gif"
            @mouseover="activateLetters"
            @mouseleave="activateLetters"
            @Touchstart="activateLetters"
            @Touchend="activateLetters"
            height="54"
            width="54"
            alt=""
          />
          <div v-show="seen" class="text text-image">
            {{ previous_section }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigatorWork",
  props: {
    label: { type: String, default: "" },
    section: String,
    previous_section: String,
    previous_url: String,
  },
  data() {
    return { seen: false };
  },
  methods: {
    create_section() {
      let section_ = this.label.toUpperCase().split(" ");
      let section = [];
      for (let val of section_) {
        section.push(val.split(""));
      }
      return section;
    },
    activateLetters() {
      this.seen = !this.seen;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Paprika&display=swap");
#nav {
  display: flex;
  flex-direction: row;
  z-index: 99;
}

#container-header {
  position: fixed;
}

#previous-url {
  position: fixed;
  right: 33px;
}

a {
  text-decoration: none;
}

.text {
  color: #03ff00;
  font-size: 24px;
  font-family: "Paprika", regular, serif;
  max-width: 300px;
  height: 0;
}

.text-container {
  display: flex;
}

.word {
  margin-top: 17px;
  margin-left: 10px;
}

.text span {
  display: inline-block;
  -webkit-animation: wave-text 1s ease-in-out infinite;
  animation: wave-text 1s ease-in-out infinite;
}

.text-image {
  font-size: 17px;
  width: 54px;
  position: relative;
  top: -42px;
  text-align: center;
}

@-webkit-keyframes wave-text {
  0% {
    transform: translateY(0em);
  }
  60% {
    transform: translateY(-0.6em);
  }
  100% {
    transform: translateY(0em);
  }
}

@keyframes wave-text {
  0% {
    transform: translateY(0em);
  }
  60% {
    transform: translateY(-0.6em);
  }
  100% {
    transform: translateY(0em);
  }
}

/* @media only screen and (max-width: 800px) {
  #container-header {
    position: sticky;
  }
} */
</style>
